import React, {useEffect} from 'react';
import {StyleSheet, View, I18nManager, Platform} from 'react-native';
import MyStack from './MainRoots/Route';
import RootView from './MainRoots/RootView';
import {LogBox} from 'react-native';
import TagManager from 'react-gtm-module';
import {ErrorBoundary} from '@sentry/react';
import AppConstants from '../src/Constants/AppConstants';
import {getValuesFromCookies} from './HelperClasses/UserPrefrences';
import Root from './Routes/root';

import AllRoutes from './MainRoots/AllRoutes';
import {ThemeProvider} from './HelperClasses/ThemeContext';
import {LocaleProvider} from './Localization/LocaleContext';

const AppConstant = require('../src/Constants/AppConstants');
const tagManagerArgs = {
  gtmId: 'GTM-N6RFH7D',
};
const lang = 'ar';

export default function App() {
  useEffect(() => {
    let lng = getValuesFromCookies('appLanguage');
    AppConstant.appLanguage = lng;
    I18nManager.allowRTL(lng == lang ? true : false);
    I18nManager.forceRTL(lng == lang ? true : false);

    LogBox.ignoreAllLogs();
    if (AppConstant.env == 'sandbox' || AppConstant.env == 'production') {
      TagManager.initialize(tagManagerArgs);
    }
    if (Platform.OS === 'web') {
      document.body.style = 'height: 100%';
    }
  }, []);

  // useEffect(() => {
  //   const observer = new MutationObserver(mutations => {
  //     mutations.forEach(mutation => {
  //       mutation.addedNodes.forEach(node => {
  //         if (
  //           node.tagName === 'IFRAME' &&
  //           node.style.position === 'fixed' &&
  //           node.style.top === '0px' &&
  //           node.style.left === '0px' &&
  //           node.style.width === '100%' &&
  //           node.style.height === '100%' &&
  //           node.style.border === 'none' &&
  //           node.style.zIndex === '2147483647'
  //         ) {
  //           setTimeout(() => {
  //             node.style.display = 'none';
  //           }, 0); // Delay for smoother handling on iOS
  //         }
  //       });
  //     });
  //   });

  //   observer.observe(document.body, { childList: true, subtree: true });

  //   return () => observer.disconnect();
  // }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      document.querySelectorAll('iframe').forEach(iframe => {
        if (
          iframe.style.position === 'fixed' &&
          iframe.style.top === '0px' &&
          iframe.style.left === '0px' &&
          iframe.style.width === '100%' &&
          iframe.style.height === '100%' &&
          iframe.style.border === 'none' &&
          iframe.style.zIndex === '2147483647'
        ) {
          iframe.style.display = 'none';
        }
      });
    }, 500); // Adjust the interval as needed

    return () => clearInterval(intervalId);
  }, []);

  return (
    //<RootView />
    //<MyStack />
    <ErrorBoundary>
      <ThemeProvider>
        <LocaleProvider>
          <AllRoutes />
        </LocaleProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
